export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";